import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-cod-detail-loading-card',
    templateUrl: './cod-detail-loading-card.component.html',
    imports: [CommonModule],
    standalone: true
})
export class CodDetailLoadingCardComponent {}
